import httpRequest from "../utils/axios.js";
import config from "./config.js";

/**
 * 获取洗车门店列表
 */
export function getStoreList(longitude, latitude) {
  var url = config.getStoreList;
  var jsondata={
    longitude,
    latitude
  };
  return httpRequest.fetchGet(url, jsondata)
} 

/**
 * 卡券购买
 */
export function couponExchange(data) {
  var url = config.couponExchange;
  return httpRequest.fetchPost(url, data)
} 

/**
 * 获取卡券核销码
 */
export function getCouponVerifyCode(couponId, cityCode, shopId) {
  var url = config.getCouponVerifyCode;
  var jsondata={
    couponId,
    cityCode,
    shopId
  };
  return httpRequest.fetchGet(url, jsondata)
} 

/**
 * 查询单张卡券
 */
export function queryCoupon(couponId) {
  var url = config.queryCoupon;
  var jsondata={
    couponId
  };
  return httpRequest.fetchGet(url, jsondata)
} 

/**
 * 获取核销卡券数量
 */
export function getVerifyCouponsCount(productId) {
  var url = config.getVerifyCouponsCount;
  var jsondata={
    productId
  };
  return httpRequest.fetchGet(url, jsondata)
} 